import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MenuController} from '@ionic/angular';
import {CommonUtils} from '../../utils/common';
import {AuthService} from '../../providers/auth.service';
import {UserAuthData} from "../../models/user-auth-data.model";
import {Subscription} from "rxjs";
import {User} from "../../models/user.model";
import {UserService} from "../../providers/user.service";
import VV from "../../../assets/vv.json"
import {ClientsService} from "../../providers/clients.service";
import {Client} from "../../models/client.model";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {map} from "rxjs/operators";
import {AppStateService} from "../../providers/app-state.service";

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent implements OnInit, OnDestroy {
  @Input() contentContainerId: string;

  private userAuthData: UserAuthData;

  v;

  user: User;
  isAdmin: boolean;
  userSub: Subscription;
  isGeneralAdmin: boolean;
  isVMessagesRole: boolean;
  isPaymentRole: boolean;
  isPartnerBannerActionsRole: boolean;
  isUsersRole: boolean;
  isCallCenterRole: boolean;
  isPrepaidRole: boolean;
  isRefundRole: boolean;
  hasOrdersRole: boolean;
  hasVetReservationRole: boolean;
  hasClientsRole: boolean;
  hasArticlesRole: boolean;
  hasLeadsRole: boolean;
  hasReferralsRole: boolean;
  hasCategoryRole: boolean;
  hasArticlesRedactorRole: boolean;
  vClient: Client;
  hasSalesManagerRole: boolean;
  informationObligationCanBeEdited: boolean = true;
  clientSub: Subscription;
  clinicSub: Subscription;
  private paymentsEnabledSub: Subscription;
  private paymentsEnabled: boolean;
  hasClinicsRole: boolean;
  toaVetineo: boolean;
  iobVetineo: boolean;
  hasVetineoSalesManagerRole: boolean;
  hasVetineoClientsRole: boolean;
  hasLabTestDataRole: boolean;
  hasAmbassadorProgram: boolean = false;
  hasWellnessPlansRoles: boolean;
  isProductRecommendationRole: boolean;
  pragmaticBox: boolean = false;
  visitTypeConfigAllowed: boolean = false;



  constructor(
    private router: Router,
    private menu: MenuController,
    public commonUtils: CommonUtils,
    private authService: AuthService,
    private userService: UserService,
    private vClientService: ClientsService,
    private clinicService: VetClinicService,
    private appStateService: AppStateService) {
  }

  ngOnDestroy(): void {
    if (this.userSub) {
      this.userSub.unsubscribe()
    }
    if (this.clientSub) {
      this.clientSub.unsubscribe()
    }
    if (this.clinicSub) {
      this.clinicSub.unsubscribe()
    }
  }

  ngOnInit() {
    this.v = VV;
    this.isAdmin = false;

    this.appStateService.networkStatusSubject.pipe(map(status => {
      return status?.connected;
    })).subscribe(isConnected => {

      if (isConnected) {
        this.authService.getUserAuthData().subscribe(e =>{
          if(e){
            this.userService.getUser().subscribe(u => {
              if (u !== null) {

                this.userService.checkUserRecommendationAllowed().subscribe(recAllowed => {
                  if (recAllowed) {
                    this.pragmaticBox = true;
                  }
                });

                this.userService.checkUserCanEditVetineoVisitTypes().subscribe(visitTypeConfigAllowed => {
                  if (visitTypeConfigAllowed) {
                    this.visitTypeConfigAllowed = true;
                  }
                });

                if(!this.isGeneralAdmin){
                  if (u.vClientUUID){
                    this.clientSub = this.vClientService.getClientByUUID(u.vClientUUID).subscribe(e=>{
                      if(e){
                        this.vClient = e;
                        // if (this.vClient.partnerUUID) {
                        //   this.hasAmbassadorProgram = true;
                        // }

                      }
                    })
                  } else {
                    this.hasVetineoClientsRole = true;
                  }
                  if(u.vetcodeId){
                    this.clinicSub = this.clinicService.getVetClinic().subscribe(value => {
                      if(value && value.paymentsEnabled){
                        this.informationObligationCanBeEdited = false;
                      }
                    })
                  }
                }

                this.user = this.commonUtils.bestTypedCopyEver<User>(new User(), u);
                this.isAdmin = this.filterRoleContains(u, 'admin');
                this.isGeneralAdmin = this.isAdmin && u.vClientId === null && u.vetcodeId ===null;
                this.isPaymentRole = this.filterRoleContains(u, 'payments');
                this.isPartnerBannerActionsRole = this.filterRoleContains(u, 'partner-banner-actions');
                this.isVMessagesRole = this.filterRoleContains(u, 'v-messages');
                this.isUsersRole = this.filterRoleContains(u, 'users');
                this.isCallCenterRole = this.filterRoleContains(u, 'call-center');
                this.isPrepaidRole = this.filterRoleContains(u, 'prepaid');
                this.isRefundRole = this.filterRoleContains(u, 'payments-refund');
                this.hasOrdersRole = this.filterRoleContains(u, 'orders');
                this.hasVetReservationRole = this.filterRoleContains(u, 'vet-reservations');
                this.hasClientsRole = this.filterRoleContains(u, 'clients');
                this.hasArticlesRole = this.filterRoleContains(u, 'articles');
                this.hasCategoryRole = this.filterRoleContains(u, 'category');
                this.hasClinicsRole = this.filterRoleContains(u, 'vet-clinics');
                this.hasArticlesRedactorRole = this.filterRoleContains(u, 'articles-redactor');
                this.hasLeadsRole = this.filterRoleContains(u, 'sales');
                this.toaVetineo = this.filterRoleContains(u, 'vet-reservations') && !u.vClientUUID;
                this.iobVetineo = this.filterRoleContains(u, 'vet-reservations') && !u.vClientUUID;
                this.hasReferralsRole = this.filterRoleContains(u, 'referrals');
                this.hasSalesManagerRole = this.filterRoleContains(u, 'sales-manager');
                this.hasVetineoSalesManagerRole = this.filterRoleContains(u, 'vetineo-sales');
                this.hasLabTestDataRole = this.filterRoleContains(u, 'lab-test-data');
                this.hasWellnessPlansRoles = this.filterRoleContains(u, 'wellness-plans');
                this.isProductRecommendationRole = this.filterRoleContains(u, 'product-recommendations');
                this.paymentsEnabledSub = this.userService.checkIfPaymentsEnabled().subscribe(response => {
                  if (response !== undefined) {
                    this.paymentsEnabled = true;
                  }
                });

              }
            });
          }
        })
      }
    });
  }

  goTo(page: string) {
    if (this.userAuthData) {
      console.log(this.userAuthData);
    }

    this.router.navigateByUrl(page);
    this.menu.close();
  }

  logout() {
    this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz się wylogować?', 'Tak', 'Nie', 'log-out-outline', 'close', () => {
      this.menu.close().then(() => {
        this.router.navigate(['signin']).then(() =>{
          this.authService.logout();
        });
      });
    }, undefined);
  }

    filterRoleContains(user: User, role: string) {
    return user.roles?.split(';').filter(e => e === role).length === 1;
  }

  canEditCategories() {
    if(this.vClient){
      return this.vClient?.isArticleModeEnabled && (this.isAdmin || this.hasCategoryRole || this.hasArticlesRedactorRole);
    } else {
      return false;
    }
  }

  vetineoCarePlansEnabled() {
    if(this.vClient){

      // if (this.user.uuid === '79f2cb50-a0ee-4161-a058-80b247cb6773') {
      //   return true;
      // }

      //
      return this.vClient?.vetineoCarePlanEnabled && ((this.isAdmin && !this.user.vetcodeId) || this.hasWellnessPlansRoles);
      //  this.user.uuid === '79f2cb50-a0ee-4161-a058-80b247cb6773';
    } else {
      return !this.hasVetineoSalesManagerRole;
    }
  }

  canSetVetineoVisitTypes() {
    if (!this.user) {
      return false;
    }
    //
    // if (this.isAdmin && !this.user.vetcodeId && (this.user.uuid === '4ab9d393-5fc5-40ef-9da4-2cd5ae1bafb4' || this.user.uuid === '79f2cb50-a0ee-4161-a058-80b247cb6773' || this.user.uuid === '2786d1ac-08b8-4af1-84b6-83d7d0075ee0')) {
    //  return true;
    // }

    return this.visitTypeConfigAllowed;


    // return !this.user?.vetcodeId && !this.user.vClientId;
  }

  isPartnerPragmaticBox() {
   return this.pragmaticBox;
  }
}
